module.exports = __webpack_public_path__ + "static/media/IconLightning.28946b01.svg";